'use client';

import Env from 'src/environmentVariables/EnvironmentVariables';
import useInterval from './useInterval';

const DEFAULT_UI_UPDATE_INTERVAL = 10_000;

/**
 * Calls a callback function on mount and at a pre-determined interval (`Env.uiUpdateIntervalMs`) afterwards.
 * This keeps the update frequency consistent across the app.
 *
 * @param callback Callback that ideally should be wrapped in `useCallback` to prevent unnecessary re-renders.
 * @param essential If true, the callback will be called at a higher frequency (`Env.uiEssentialUpdateIntervalMs`).
 * @param runOnCallbackChange If true, the callback will be called immediately after the callback function changes.
 * @param disabled If true, disables the interval.
 */
const useUiUpdateInterval = (
	callback: () => void,
	essential: boolean,
	runOnCallbackChange: boolean,
	disabled?: boolean
) => {
	const intervalMs = essential
		? Env.uiEssentialUpdateIntervalMs
		: Env.uiNonEssentialUpdateIntervalMs;

	useInterval(
		callback,
		disabled ? null : (intervalMs ?? DEFAULT_UI_UPDATE_INTERVAL),
		runOnCallbackChange
	);
};

export default useUiUpdateInterval;
